module.exports = __webpack_public_path__ + "static/media/video1.ea5da751.mp4";